import { getBranchen } from '../api/branchen-api.js'
import '../../../node_modules/babel-polyfill'

export async function determineHeroImages(source){

    let branches = await getBranchen();
    
    if(source.hasOwnProperty('basics')) {
        
        let heroImage = false;
        
        source.pictures.forEach(element => {
            if(element.type == 'heroimage') {
                heroImage = true;
            }
        });
        if(!heroImage){
            let path;
            if(source.branches.length == 0){
                // in case backend response comes without an branche_id
                path = getParentBranchImagePath(63, branches, source.basics[0].istPremium)
            } else {
                path = getParentBranchImagePath(source.branches[0].branche_id, branches, source.basics[0].istPremium)
            }           
            source.basics[0].image_url = path;            
        }

        return source;

    } else {

        for (let i = 0; i < source.length; i++) {

            if(source[i].image_url == null){
                let brancheId = source[i].parent_branche_id
                if(brancheId === undefined){brancheId = source[i].branche_id};
                source[i].image_url = getParentBranchImagePath(brancheId, branches, source[i].istPremium);
            }                
        }
    }
    return source;
};
function getParentBranchImagePath(id, branches, premium) {
    let parentId = null;
    let parentBranchPath = '';
    let path = '';

    if(branches !== undefined){
        for (let i = 0; i < branches.length; i++) {
            for (let j = 0; j < branches[i].sub_branchen.length; j++) {
                if(branches[i].sub_branchen[j].id == id) {
                    parentId = branches[i].id
                    if(premium == '1'){
                        parentBranchPath = branches[i].image_url;
                    } else {
                        parentBranchPath = branches[i].image_grey_url;
                    }         
                }            
            }        
        }
    }

    if(parentId === null){
        if(premium === '1') {
            path = process.env.BACKEND_BASE_URL + '/img/branchen/63.jpg'
        } else {
            path = process.env.BACKEND_BASE_URL + '/img/branchen/63grey.png';
        }
    } else {
        path = parentBranchPath;
    }
    
    return path;
}

